<script setup>
import { nextTick, onMounted, ref, watch } from 'vue';
import { renderEmoji } from 'shared/helpers/twemoji';

const props = defineProps({
  emoji: {
    type: String,
    required: true,
  },
  size: {
    type: String,
    default: '',
  },
});

defineOptions({ inheritAttrs: false });

const glyph = ref(null);

const renderGlyph = async () => {
  await nextTick();
  renderEmoji(glyph.value, { loading: 'eager' });
};

watch(() => props.emoji, renderGlyph, { flush: 'post' });
onMounted(renderGlyph);
</script>

<template>
  <span
    v-bind="$attrs"
    ref="glyph"
    class="inline-block h-[1em] w-[1em] align-[-0.125em]"
    :class="{
      '!h-[1.25rem] !w-[1.25rem] text-[1.25rem]': size === 'reaction',
    }"
  >
    {{ emoji }}
  </span>
</template>
